<div class="groups-checkbox">
  <mat-checkbox (change)="onCheckboxToggle($event)" [checked]="checkedStatus()"></mat-checkbox>
</div>
